"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var dealerPageInfoStyles_1 = require("./dealerPageInfoStyles");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
var useCheckoutContext_1 = require("../../../../common/hooks/useCheckoutContext");
var DealerPageInfo = function () {
    var isStock = useCheckoutContext_1.default().isStock;
    var infoTranslationId = isStock
        ? 'trans__checkout__dealers_page__dealer_step_with_stock_description'
        : 'trans__checkout__dealers_page__dealer_step_non_stock_description';
    var styles = dealerPageInfoStyles_1.default();
    return (<core_1.Box className={styles.infoContainer} data-test="checkout:dealer:infoContainer">
      <core_1.Typography variant="caption" className={styles.info} data-test="text:dealer:info">
        <Translation_1.default id={infoTranslationId}/>
      </core_1.Typography>
    </core_1.Box>);
};
exports.default = DealerPageInfo;
